import React from 'react'
import { string, bool, func } from 'prop-types'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { AnimatePresence, motion } from 'framer-motion'

import { Slide } from '../../animations'
import { layoutMessages } from '../../translations'

const NotificationWrapper = styled(motion.div)`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  top: 0;
  right: 0;
  z-index: 9999;

  .success {
    border-top: 2px solid #5ea400;
    background-color: #f0f5ea;
    color: #4b583a;
    box-shadow: 0 0 1px rgba(94, 164, 0, 0.9);
  }

  .error {
    border-top: 2px solid #ec3d3d;
    background-color: #f4e9e9;
    color: #412f2f;
    box-shadow: 0 0 1px rgba(236, 61, 61, 0.9);
  }
`

const Notification = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 9999;

  box-sizing: border-box;
  position: relative;
  font-size: ${rem(13)};
  padding: 10px;
  margin-top: 10px;
  cursor: pointer;
  border-radius: 3px;
  min-width: 250px;
`

const Title = styled.div`
  font-size: ${rem(14)};
  margin: 0 0 5px 0;
  font-weight: bold;
  color: ${({ error }) => (error ? '#ec3d3d' : '#5ea400')};
`

const Dismiss = styled.div`
  cursor: pointer;
  font-size: 12px;
  position: absolute;
  top: 4px;
  right: 5px;
  background-color: ${({ error }) => (error ? '#e4bebe' : '#b0ca92')};
  color: ${({ error }) => (error ? '#f4e9e9' : '#f0f5ea')};
  border-radius: 50%;
  width: 14px;
  height: 14px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1.2;
`

export const Toast = ({ error, message, show, setShow }) => {
  const { formatMessage } = useIntl()
  const { initial, animate } = Slide(true, { start: 300, end: 0 }, { start: 0, end: 0 })

  return (
    <AnimatePresence exitBeforeEnter>
      <>
        {show && (
          <NotificationWrapper
            key='toast-notification'
            initial={initial}
            animate={animate}
            exit={initial}
          >
            <Notification onClick={() => setShow(false)} className={error ? 'error' : 'success'}>
              <Title error={error}>
                {error
                  ? formatMessage(layoutMessages.error)
                  : formatMessage(layoutMessages.success)}
              </Title>
              <div>{error && !message ? formatMessage(layoutMessages.errorTitle) : message}</div>
              <Dismiss error>x</Dismiss>
            </Notification>
          </NotificationWrapper>
        )}
      </>
    </AnimatePresence>
  )
}

Toast.propTypes = {
  error: bool,
  message: string,
  show: bool,
  setShow: func,
}
